// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ld-0";
export var buttonContainer = "_ld-3";
export var cancelButton = "_ld-4";
export var headerSection = "_ld-6";
export var headerTitle = "_ld-9";
export var messageSideLeft = "_ld-1";
export var messageSideRight = "_ld-2";
export var orderNumberContainer = "_ld-7";
export var orderNumberLabel = "_ld-8";
export var submitButton = "_ld-5";